<template>
  <v-dialog :value="true" persistent max-width="500">
    <v-card class="blue darken-2 pt-10 init-block-left white--text text-center" tile>
      <v-img src='@/assets/still.png' height="100" class="pt-1" contain/>
      <div class="text-h3 pt-10">PŪRTRAK</div>
      <div class="text-h6 pt-4">DISTILLERY MANAGEMENT</div>
      <div class="pt-4">Version <span class="text-decoration-underline cursor-pointer" @click="versionSummary()">{{version}}</span></div>
      <div class="pt-4">&copy; Copyright 2022, Purtrak Inc. All rights reserved.</div>
      <div><span @click="terms=true" class="text-decoration-underline cursor-pointer">Terms of use</span> - <span @click="privacy=true" class="text-decoration-underline cursor-pointer">Privacy policy</span></div>
      <v-btn color="white" class="my-6" @click="cancel()">Done</v-btn>
    </v-card>

    <terms-of-use v-model="terms"/>
    <privacy-policy v-model="privacy"/>
    <component :is="dialog" :version="version" @done="dialog = null"/>
  </v-dialog>
</template>

<script>
import TermsOfUse from '@/views/login/TermsOfUse'
import PrivacyPolicy from '@/views/login/PrivacyPolicy'

export default {
  name: 'LoginAbout',
  components: {TermsOfUse,PrivacyPolicy},
  data() {
    return {
      terms: false,
      privacy: false,
			dialog: null
    }
  },
  computed: {
    version() {
      return this.$store.state.newVersion ? this.$store.state.oldVersion : this.$store.state.version;
    }
  },
  methods: {
    versionSummary() {
      this.dialog = () => import('@/views/login/VersionSummary');
    },
    cancel() {
      this.$emit('done');
    }
  }
}
</script>